import {get} from 'lodash';
import {gql} from "apollo-boost";
import client from '../../../graphql/client';
import refactorRespImg from '../../ui/resp-img';

const refactorCalculatorBannerData = async (data) => {
  
  const result = await client.query({
    query: gql`
      query GET_DEALERS {
        dealers(first: 1000) {
          nodes {
            title
            acf_dealers {
              dealerID
              latitude
              longitude
              postcodes
            }
          }
        }
      }
    `
  });
  var dealers = [];
  get(result, 'data.dealers.nodes', []).map(item => {
    if (get(item, 'acf_dealers.postcodes[0]', null)) {
      dealers.push({
        title: item.title,
        acf_dealers: {
          id: item.acf_dealers.dealerID,
          latitude: item.acf_dealers.latitude,
          longitude: item.acf_dealers.longitude,
          postcodes: item.acf_dealers.postcodes
        }
      });
    }
  });

  var obj = {
    title: get(data, 'title', ''),
    subtext: get(data, 'subtext', ''),
    image: get(data, 'cbImage', null) ? refactorRespImg(
      data.cbImage, [{size: 'md', key: 'image_size_1600x775'}, {size: 'default', key: 'image_size_840x775'}]
    ) : null,
    dealers
  };
  // console.log('refactorCalculatorBannerData>>>');
  // console.dir(obj, {depth:null});

  return obj;

}

export default refactorCalculatorBannerData